import { put, call } from 'redux-saga/effects';
import * as actions from '../actions';
import { submitApplication, uploadFile } from '../../api/application';
import * as utilities from '../utility';

function* submitApplicationSaga(action) {
    yield put(actions.registerLoading());
    try {
        let licenseFiles = [];

        try {
            for (let i = 0; i < action.licenseFiles.length; i++) {
                const responseUpload = yield call(uploadFile, action.licenseFiles[i], 'manual');
                const supFile = {
                    storageKeyFileName: responseUpload.data.data.storageKey,
                    storageDisplayName: responseUpload.data.data.displayName,
                    fileType: action.licenseFiles[i].type,
                };
                licenseFiles = [...licenseFiles, supFile];
            }
        } catch (err) {
            console.warn(err);
        }

        action.applicantDetails.drivingLicense.supportingDocuments = licenseFiles.length > 0 ? licenseFiles : [];

        let employmentFiles = [];

        try {
            for (let i = 0; i < action.employmentFiles.length; i++) {
                const responseUpload = yield call(uploadFile, action.employmentFiles[i], 'manual');
                const supFile = {
                    storageKeyFileName: responseUpload.data.data.storageKey,
                    storageDisplayName: responseUpload.data.data.displayName,
                    fileType: action.employmentFiles[i].type,
                };
                employmentFiles = [...employmentFiles, supFile];
            }
        } catch (err) {
            console.warn(err);
        }

        action.applicantDetails.employment.supportingDocuments = employmentFiles.length > 0 ? employmentFiles : [];

        const submitApplicationFormViewModel = {
            applicationDetails: action.applicationDetails,
            applicantDetails: action.applicantDetails,
        };

        if (submitApplicationFormViewModel.applicantDetails.drivingLicense.qdl) {
            submitApplicationFormViewModel.applicantDetails.drivingLicense.qdl.expirydate = submitApplicationFormViewModel.applicantDetails.drivingLicense.qdl.expirydate? utilities.formatToDateTime(submitApplicationFormViewModel.applicantDetails.drivingLicense.qdl.expirydate) : null;
            submitApplicationFormViewModel.applicantDetails.drivingLicense.qdl.classes.forEach(element => {
                element.issueDate = element.issueDate !== '' ? utilities.formatToDateTime(element.issueDate) : null;
            });
        }

        if (submitApplicationFormViewModel.applicantDetails.drivingLicense.pdl) {
            submitApplicationFormViewModel.applicantDetails.drivingLicense.pdl.expirydate =
            submitApplicationFormViewModel.applicantDetails.drivingLicense.pdl.expirydate !== ''
                    ? utilities.formatToDateTime(submitApplicationFormViewModel.applicantDetails.drivingLicense.pdl.expirydate)
                    : null;
        }

        const responseSubmitApp = yield call(submitApplication, submitApplicationFormViewModel);
        yield put({ type: actions.onSubmitApplicationSuccess(responseSubmitApp.data.data) });
        if (action.applicationDetails.callBackUrl === null || action.applicationDetails.callBackUrl === '') {
            yield put(actions.stageSuccess(9));
        } else {
            window.location = action.applicationDetails.callBackUrl;
        }
    } catch (error) {
        yield put(actions.stageSuccess(11));
        yield put({ type: actions.onSubmitApplicationFailed(error.response.data) });
    }

    yield put(actions.unregisterLoading());
}

export default submitApplicationSaga;
